import { useLocation, useParams } from "react-router-dom";
import styles from "./NavbarCategory.module.css";

import {
  BreadCrumb,
  Banner,
} from "../../../components/shared/index";

import { useInfiniteProductsQuery } from "../../../queries/useProductsQuery";
import { ShopProducts } from "../../../components/web-app";


// import { ShopProducts } from "../../web-app/index";

const formatLabel = (text = "") =>
  text
    .replace(/[_-]/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());

const NavCategoryPage = ({ slug: propSlug }) => {
  const params = useParams();


  // use prop if available, otherwise fallback to URL param
  const slug = propSlug || params.slug;

  const { pathname } = useLocation();

  const parts = pathname.split("/");
  const newPath = parts[parts.length - 1];

  const categoryName = formatLabel(slug);

  const {
    data,
    isPending,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteProductsQuery(
    {
      category: slug,
    },
    {
      keepPreviousData: true,
    }
  );

  const products =
    data?.pages?.flatMap((page) => page?.products?.data || []) || [];

  return (
    <section className={styles.categoryPage}>
      <BreadCrumb
        customPaths={[
          {
            label: categoryName,
            path: newPath,
          },
        ]}
      />

      <Banner
        heading={`Welcome to ${categoryName} Category`}
        imageUrl="https://plus.unsplash.com/premium_photo-1664202526559-e21e9c0fb46a?w=1600"
      />

      <div className={styles.productsWrapper}>
        <ShopProducts
          products={products}
          isPending={isPending}
          isError={isError}
          hasMore={hasNextPage}
          isFetching={isFetchingNextPage}
          lastItemRef={fetchNextPage}
          imageOnly={true}
        />
      </div>

    
    </section>
  );
};

export default NavCategoryPage;

